import React from 'react';
import { create } from 'zustand';

export type LoadingIndicatorState = {
  loading: boolean;
};

export type LoadingIndicatorActions = {
  show: () => void;
  hide: () => void;
};

export type LoadingIndicatorStore = LoadingIndicatorState & LoadingIndicatorActions;

export const useLoadingIndicatorStore = create<LoadingIndicatorStore>((set) => ({
  loading: false,

  show: () => set({ loading: true }),
  hide: () => set({ loading: false }),
}));

export const useLoading = (isLoading: boolean) => {
  const { show, hide } = useLoadingIndicatorStore();

  React.useEffect(() => {
    if (isLoading) {
      show();
    } else {
      hide();
    }
  }, [isLoading, show, hide]);
};
